import 'angular:locale/data:ru';
import 'angular:locale/data:uk';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
